import React from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import featureEnabled from 'shared/helper/feature';
import RubriqCart from './plan/RubriqCart';
import RubriqIthenticateCartWrapper from './plan/RubriqIthenticateCartWrapper';
import RubriqWorkspace from './workspace/RubriqWorkspace';
import RubriqWorkspaceOld from './workspace/RubriqWorkspaceOld';
import RubriqTranslation from './workspace/RubriqTranslation';
import RubriqEditing from './workspace/RubriqEditing';
import RubriqAbstract from './workspace/RubriqAbstract';
import RubriqPlagiarism from './workspace/Plagiarism/RubriqPlagiarism';
import Subscriptions from './plan/Subscriptions';
import SubscriptionsOld from './plan/SubscriptionsOld';
import RubriqROWPurchaseSummary from './plan/RubriqROWPurchaseSummary';
import RubriqROWPurchaseSummaryOld from './plan/RubriqROWPurchaseSummaryOld';
import RubriqLoader from './components/RubriqLoader';
import RubriqAbstractWriter from './workspace/abstract-writer/RubriqAbstractWriter';
import RubriqSetupWizard from './workspace/abstract-writer/RubriqSetupWizard';
import RubriqSetupStep from './workspace/abstract-writer/RubriqSetupStep';
import RubriqTemplate from './workspace/abstract-writer/RubriqTemplate';
import RubriqReview from './workspace/abstract-writer/RubriqReview';
import PaddleInvoiceFapiaoRequestContainer from './fapiao/PaddleInvoiceFapiaoRequestContainer';
import PaddleInvoiceContainer from './fapiao/PaddleInvoiceContainer';
import RubriqPaddlePaymentsPage from './fapiao/RubriqPaddlePaymentsPage';
import RubriqNewCart from './plan/RubriqNewCart';
export var Routes = function Routes() {
  var abstractWriterEnabled = false;
  var rowFreeTrialThroughPaddle = featureEnabled('curie_row_free_trials_through_paddle');
  var rubriqPlagiarismEnabled = featureEnabled('rubriq_plagiarism');
  var showNewComponent = featureEnabled('rubriq_ui_revamp');
  var rubriqAbstractEnabled = featureEnabled('rubriq_abstract');
  return /*#__PURE__*/React.createElement(RubriqLoader, null, /*#__PURE__*/React.createElement(RouterRoutes, null, /*#__PURE__*/React.createElement(Route, {
    path: "subscribe/:receiptCode?/:success?",
    element: /*#__PURE__*/React.createElement(RubriqCart, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "ithenticate/subscribe/:receiptCode?/:fileId?/:success?",
    element: /*#__PURE__*/React.createElement(RubriqIthenticateCartWrapper, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "subscribe/cart/editing/:receiptCode?/:success?",
    element: /*#__PURE__*/React.createElement(RubriqNewCart, {
      premium: true
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "subscribe/cart/translation/:receiptCode?/:success?",
    element: /*#__PURE__*/React.createElement(RubriqNewCart, {
      premium: false
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "plan"
  }, /*#__PURE__*/React.createElement(Route, {
    path: "",
    element: showNewComponent ? /*#__PURE__*/React.createElement(Subscriptions, null) : /*#__PURE__*/React.createElement(SubscriptionsOld, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "subscribe",
    element: showNewComponent ? /*#__PURE__*/React.createElement(Subscriptions, {
      showPlans: true
    }) : /*#__PURE__*/React.createElement(SubscriptionsOld, {
      showPlans: true
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "subscribe/premium",
    element: showNewComponent ? /*#__PURE__*/React.createElement(RubriqROWPurchaseSummary, {
      freeTrial: false
    }) : /*#__PURE__*/React.createElement(RubriqROWPurchaseSummaryOld, {
      freeTrial: false
    })
  }), rowFreeTrialThroughPaddle && /*#__PURE__*/React.createElement(Route, {
    path: "subscribe/freetrial",
    element: showNewComponent ? /*#__PURE__*/React.createElement(RubriqROWPurchaseSummary, {
      freeTrial: true
    }) : /*#__PURE__*/React.createElement(RubriqROWPurchaseSummaryOld, {
      freeTrial: true
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "subscribe/sn-freetrial",
    element: showNewComponent ? /*#__PURE__*/React.createElement(RubriqROWPurchaseSummary, {
      snTrial: true
    }) : /*#__PURE__*/React.createElement(RubriqROWPurchaseSummaryOld, {
      snTrial: true
    })
  })), /*#__PURE__*/React.createElement(Route, {
    path: "",
    element: showNewComponent ? /*#__PURE__*/React.createElement(RubriqWorkspace, null) : /*#__PURE__*/React.createElement(RubriqWorkspaceOld, null)
  }, /*#__PURE__*/React.createElement(Route, {
    path: "",
    element: /*#__PURE__*/React.createElement(RubriqEditing, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "editing",
    element: /*#__PURE__*/React.createElement(RubriqEditing, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "translation",
    element: /*#__PURE__*/React.createElement(RubriqTranslation, null)
  }), rubriqPlagiarismEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "plagiarism",
    element: /*#__PURE__*/React.createElement(RubriqPlagiarism, null)
  }), rubriqAbstractEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "abstract",
    element: /*#__PURE__*/React.createElement(RubriqAbstract, null)
  }), abstractWriterEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "abstract-writer",
    element: /*#__PURE__*/React.createElement(RubriqAbstractWriter, null)
  }), abstractWriterEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "abstract-writer/:sessionIdentity/criteria",
    element: /*#__PURE__*/React.createElement(RubriqSetupWizard, null)
  }, /*#__PURE__*/React.createElement(Route, {
    path: ":step",
    element: /*#__PURE__*/React.createElement(RubriqSetupStep, null)
  })), abstractWriterEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "abstract-writer/:sessionIdentity/template",
    element: /*#__PURE__*/React.createElement(RubriqTemplate, null)
  }), abstractWriterEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "abstract-writer/:sessionIdentity/review",
    element: /*#__PURE__*/React.createElement(RubriqReview, null)
  })), /*#__PURE__*/React.createElement(Route, {
    path: ":receiptCode/fapiao",
    element: /*#__PURE__*/React.createElement(PaddleInvoiceFapiaoRequestContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "invoices",
    element: /*#__PURE__*/React.createElement(PaddleInvoiceContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "fapiao",
    element: /*#__PURE__*/React.createElement(PaddleInvoiceFapiaoRequestContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "invoices",
    element: /*#__PURE__*/React.createElement(RubriqPaddlePaymentsPage, null)
  })));
};
export default Routes;